import * as React from "react";
import Link from "gatsby-link";
import { Container } from "reactstrap";
import styled from "styled-components";
import { ThemeContextConsumer } from "../context/ThemeContext";

export const enum HeaderTheme {
  DARK = "#000",
  LIGHT = "#fff"
}

const Wrapper = styled.header`
  position: absolute;
  top: 35px;
  left: 0;
  width: 100%;
  z-index: 99999;
  color: ${(props: any) => props.theme};
  transition: color .3s;
  will-change: transform;
`;

const ExtendedContainer = styled(Container)`
  display: flex;
  align-items: center;
`;

const Logo = styled.svg`
  fill: currentColor;
`;
const Hamburger = styled.div`
  margin-left: auto;
`;

const HamburgerBar = styled.div`
  width: 30px;
  height: 4px;
  background-color: #fff;

  & + & {
    margin-top: 6px;
  }
`;

const Header = () => (
  <ThemeContextConsumer>
    {({header}) => (
      <Wrapper theme={header}>
        <ExtendedContainer>
          <h1 style={{ margin: 0 }}>
            <Link to="/" />
          </h1>
          <Logo
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100.018 37.014"
            height="30px"
          >
            <path d="M7.97 19.002H0v18.01h6.004v-4.975h1.8c4.464 0 7.23-1.246 7.23-6.352 0-4.58-1.734-6.683-7.063-6.683zm-.53 8.38H6.005v-3.757h1.51c1.01 0 1.585.547 1.585 1.662 0 1.282-.553 2.094-1.66 2.094zM23.02 19H16.98v18.01h12.048v-4.994H23.02V19.002zm37.982 6.684l-.6-.95-4.406-5.733h-5.012v18.01h6.027V29.51l.546 1.187 4.97 6.316h4.467v-18.01h-5.99v6.683zm14.004 4.326h7.004v-3.997h-7.004V24.03h7.98v-5.027h-13.96v18.01h13.98V32h-8V30.01zM84 19.002v5.02h4.986v12.99h6.023v-12.99h5.007v-5.02H84zM7.947.025H0v17.02h7.946c6.1 0 8.137-1.896 8.137-8.424 0-6.244-2.062-8.595-8.137-8.595zm-.576 12.48H6.01l-.018-7.98H7.25c1.633 0 2.665.866 2.665 4.12 0 3.68-1.177 3.86-2.545 3.86zM39.023.024H33.03L31.98 6.65l-.12 1.353-.24-1.354L30.027 0h-4.424l-1.546 6.65-.216 1.353-.167-1.354L22.385.024H15.99l4.042 17.02h5.938l.736-2.322.812-3.3.918 3.3.657 2.322h6.87l3.06-17.02zm11.734 0H42.94l-5.043 17.02h5.898l.816-3.036h3.817l.865 3.035h6.65L50.757.025zM45.45 9.98l.697-3.38.336-2.538.336 2.563.672 3.354h-2.04zm17.534 2.557h.734l2.354 4.508h6.602l-3.29-5.576c.193-.214 2.602-1.52 2.602-5.556 0-5.057-2.96-5.89-6.97-5.89H57v17.02h5.984v-4.507zm0-8.242h1.575c.768 0 1.344.836 1.344 1.738 0 1.187-.337 1.756-1.345 1.756h-1.576V4.294zm17.04 8.698h5.99v-4.98h-5.99v-3.02h6.994V.026h-13.03v17.02h6.037v-4.052zM36.03 18.99l-5.043 18.023h5.898l.816-2.973h3.818l.864 2.973h6.65L43.848 18.99h-7.82zm2.513 10.96l.695-3.38.336-2.54.336 2.564.673 3.355h-2.04z" />
          </Logo>
          <Hamburger>
            <HamburgerBar />
            <HamburgerBar />
            <HamburgerBar />
          </Hamburger>
        </ExtendedContainer>
      </Wrapper>
    )}
  </ThemeContextConsumer>
);

// export const query = graphql`
// query AboutQuery {
//   site {
//     siteMetadata {
//       title
//     }
//   }
// }
// `

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.tsx